import axios from "axios";

export const getOldOpenRequirements = async () => {
  const token = localStorage.getItem("token");

  const response = await axios.get(
    `${process.env.REACT_APP_API_URL}/old-open-requirements`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};
export const sendEscalationMail = async (
  requirements
) => {

  const token = localStorage.getItem("token");

  const response = await axios.post(

    `${process.env.REACT_APP_API_URL}/send-escalation-mail`,

    {
      requirements
    },

    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }

  );

  return response.data;

};